<template>
  <b-modal :id="id" size="xl">
    <template #modal-header="{ close }">
      <h5>{{ $t("pages.image-cropper") }}</h5>
      <b-button size="sm" variant="danger" @click="close()">
        <i class="bx bx-x"></i>
      </b-button>
    </template>

    <template #default>
      <div class="text-center">
        <div v-if="!cropImage" class="text-danger">
          <p>{{ $t("pages.image-size-error") }}</p>
        </div>
        <div v-else class="text-succes">
          <p>{{ $t("common.edit") }}</p>
        </div>
      </div>
      <input ref="imageInput" type="file" name="image" accept="image/*" @change="setImage" />

      <vue-cropper
        ref="cropper"
        :src="image"
        alt="Source Image"
        :aspect-ratio="1"
        preview=".preview-lg"
        :containerStyle="{ 'max-height': '400px', 'min-height': '400px' }"
        :imgStyle="{ 'max-height': '400px', 'min-height': '400px' }"
      />
    </template>

    <template #modal-footer>
      <div class="row mb-2">
        <div class="col-sm-2 text-center ml-4 mr-2">
          <label>{{ $t("pages.zoom") }}</label>
          <div class="btn-group btn-group-example" role="group">
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.zoom-in')" @click.prevent="zoom(0.2)">
              <i class="bx bx-zoom-in"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.zoom-out')" @click.prevent="zoom(-0.2)">
              <i class="bx bx-zoom-out"></i>
            </b-button>
          </div>
        </div>

        <div class="col-sm-2 text-center ml-2">
          <label>{{ $t("pages.rotate") }}</label>
          <div class="btn-group btn-group-example" role="group">
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.right-rotate')" @click.prevent="rotate(90)">
              <i class="bx bx-rotate-right"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.left-rotate')" @click.prevent="rotate(-90)">
              <i class="bx bx-rotate-left"></i>
            </b-button>
          </div>
        </div>

        <div class="col-sm-4 text-center ml-2 mr-1 mb-5 pt-0">
          <label class="mt-0">{{ $t("pages.move") }}</label>
          <br />
          <div class="btn-group btn-group-example" role="group">
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.left')" @click.prevent="move(10, 0)">
              <i class="bx bx-left-arrow-alt"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.up')" @click.prevent="move(0, 10)">
              <i class="bx bx-up-arrow-alt"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.down')" @click.prevent="move(0, -10)">
              <i class="bx bx-down-arrow-alt"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('pages.right')" @click.prevent="move(-10, 0)">
              <i class="bx bx-right-arrow-alt"></i>
            </b-button>
          </div>
        </div>

        <div class="col-sm-3 text-center ml-1">
          <label>{{ $t("pages.image-processing") }}</label>
          <div class="btn-group btn-group-example" role="group">
            <b-button variant="success" class="w-xs" v-b-tooltip.hover :title="$t('common.okey')" @click.prevent="cropImage">
              <i class="bx bx-check"></i>
            </b-button>
            <b-button variant="primary" class="w-xs" v-b-tooltip.hover :title="$t('common.download')" @click.prevent="showFileChooser">
              <i class="bx bx-upload"></i>
            </b-button>
            <b-button variant="danger" class="w-xs" v-b-tooltip.hover :title="$t('common.reset')" @click.prevent="reset">
              <i class="bx bx-reset"></i>
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import "cropperjs/dist/cropper.css";
import VueCropper from "vue-cropperjs";
const defaultImage = require("@/assets/images/firm.png");
export default {
  props: ["id", "src"],
  components: { VueCropper },
  data() {
    return {
      image: undefined,
    };
  },

  mounted() {
    this.image = this.src || defaultImage;
  },

  watch: {
    src(value) {
      this.image = value || defaultImage;
    },
  },

  methods: {
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    cropImage() {
      this.resizedataURL(this.$refs.cropper.getCroppedCanvas().toDataURL(), 200, 200, (blob) => {
        var base64str = blob.substr(22);
        //Max 100 KB
        if (this.calculate(base64str) > 100) {
          return this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("pages.image-size-error") });
        }
        this.$emit("cropperImage", blob);
      });
    },
    resizedataURL(datas, wantedWidth, wantedHeight, callback) {
      var img = document.createElement("img");

      img.onload = function() {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "rgb(200,0,0)";
        ctx.fillRect(40, 60, 0, 20);

        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        callback(canvas.toDataURL("image/png"));
      };

      img.src = datas;
    },
    calculate(base64String) {
      const bits = base64String.length * 6;
      const bytes = bits / 8;
      const kb = Math.ceil(bytes / 1000);

      return kb;
    },
    showFileChooser() {
      this.$refs.imageInput.click();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("alert.error") });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("alert.error") });
      }
    },
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
</style>
